import React, { useState } from "react";
// import Header from "../components/Common/Header";

function ComponyScreen() {
  const [oneWay, setOneWay] = useState(true);

  return (
    <>
      {/* <Header bgColor="bg-white/60" /> */}
      <div className="min-h-screen p-8 flex flex-col items-center bg-white text-gray-800 overflow-hidden">
        {/* 블러 원 (배경) */}
        <div className=" absolute w-[500px] h-[500px] bg-purple-300 rounded-full top-[-50px] left-[50px] filter blur-3xl opacity-40 z-0 animate-float" />
        <div className=" absolute w-[1000px] h-[1000px] bg-blue-400 rounded-full top-[70%] left-[90%] opacity-40 filter blur-3xl z-0 animate-float " />
        <div className=" absolute w-[700px] h-[700px] bg-yellow-400 rounded-full top-[90%] left-[50px] opacity-40 filter blur-3xl z-0 animate-float " />
        <main className="w-full max-w-6xl flex flex-col items-center mt-[15vh] z-10">
          <h1 className=" text-center text-5xl font-bold bg-[linear-gradient(90deg,_#e77fd1_0%,_#b18fd8_25%,_#849ce1_50%,_#80abd7_75%,_#e698be_100%)] bg-clip-text text-transparent ">
            We design for the future.
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Explore your travel opportunities with us!
          </p>
          <div className="bg-white/40 border-2 border-white/80 rounded-2xl shadow-lg w-full max-w-3xl p-6">
            {/* 탭 메뉴 */}
            <div className="flex space-x-8 mb-6">
              <button className="pb-2 border-b-2 border-black font-semibold">
                Flights
              </button>
              <button className="text-gray-400 hover:text-gray-700 transition">
                Hotels
              </button>
              <button className="text-gray-400 hover:text-gray-700 transition">
                Cars
              </button>
            </div>

            {/* 폼 */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Leaving from
                </label>
                <input
                  type="text"
                  defaultValue="Georgia, Tbilisi"
                  className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-purple-300"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Destination
                </label>
                <input
                  type="text"
                  defaultValue="France, Paris"
                  className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-purple-300"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Passengers
                </label>
                <input
                  type="text"
                  defaultValue="2 adults, 3 child, 1 pet"
                  className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-purple-300"
                />
              </div>
            </div>

            {/* 스위치 */}
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium">One way</span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={oneWay}
                  onChange={() => setOneWay(!oneWay)}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-purple-200 rounded-full peer-checked:bg-purple-500 transition-all relative after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full" />
              </label>
            </div>

            {/* 검색 버튼 */}
            <button className="w-full bg-purple-500 text-white py-2 rounded-md font-semibold hover:bg-purple-600 transition-colors">
              Search
            </button>
          </div>
        </main>
      </div>
    </>
  );
}

export default ComponyScreen;
